import { render, staticRenderFns } from "./WeatherForecast.vue?vue&type=template&id=b9563c2a&scoped=true&"
import script from "./WeatherForecast.vue?vue&type=script&lang=js&"
export * from "./WeatherForecast.vue?vue&type=script&lang=js&"
import style0 from "./WeatherForecast.vue?vue&type=style&index=0&id=b9563c2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9563c2a",
  null
  
)

export default component.exports